import * as React from 'react';
import { getContentColor, getAllProducts } from '../shared/ProductColors';
import styles from './PlanningGrid.module.scss';

const LEGEND_ITEMS = [
  ...getAllProducts().slice(0, 10),
  'VND', 'OD', 'TVX', 'EPREUVE',
  'VND/OD',
];

export const PlanningLegend: React.FC = () => {
  return (
    <div className={styles.legend}>
      {LEGEND_ITEMS.map((item, idx) => {
        const color = getContentColor(item);
        return (
          <div
            key={item}
            className={styles.legendItem}
            style={{ animationDelay: `${idx * 0.04}s` }}
          >
            <div
              className={styles.legendSwatch}
              style={{ backgroundColor: color.background }}
            />
            <span>{item}</span>
          </div>
        );
      })}
    </div>
  );
};
